import React from "react";
import { Box } from "@mui/material";

interface ProgressBarProps {
  value: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value }) => (
  <Box
    role="progressbar"
    aria-valuemin={0}
    aria-valuemax={100}
    aria-valuenow={Math.round(value)}
    sx={{ width: "100%", height: 6, bgcolor: "#E6EFF7" }}
  >
    <Box
      sx={{
        width: `${value}%`,
        height: "100%",
        bgcolor: "#0055A4",
        transition: "width 300ms ease",
        borderRadius: "0 3px 3px 0",
      }}
    />
  </Box>
);

export default ProgressBar;